import { getArrayRemove, getFirestore } from '../../system/firebase';

import {
    SNACK_BAR_MESSAGE_OPERATION_FAILED,
    SNACK_BAR_MESSAGE_SAVE,
    SNACK_BAR_MESSAGE_CONFIRM,
    SNACK_BAR_MESSAGE_DECLINE,
    SNACK_BAR_MESSAGE_INTERVIEW_SUCCESS,
    INTERVIEW_STATUS_CONFIRMED,
    INTERVIEW_STATUS_RESCHEDULE_EMP,
    INTERVIEW_STATUS_DECLINED,
    USER_TYPE_JS,
    INTERVIEW_STATUS_RESCHEDULE_JS,
    SNACK_BAR_MESSAGE_INTERVIEW_RESCHEDULED,
} from '../constants';
import { getCombinedDateTime } from '../dateHelper';

import { startOfMonth, endOfMonth, getMonth, startOfDay, isEqual as isEqualDate /*, format as formatDate*/ } from 'date-fns';

import _get from 'lodash/get';
import _set from 'lodash/set';
import _map from 'lodash/map';
import _forEach from 'lodash/forEach';
import _findKey from 'lodash/findKey';
import _isEmpty from 'lodash/isEmpty';

const mapFirebaseTimestampsToDate = (data, timestampFieldNameList) => {
    _forEach(timestampFieldNameList, fieldName => {
        const field = _get(data, fieldName);
        if (field) {
            _set(data, fieldName, field.toDate());
        }
    });
    return data;
};

export const loadInterviewCard = (interviewId, setInterviewData, setInterviewCardOpen) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return interviewRef.onSnapshot(doc => {
        if (doc.exists) {
            let data = doc.data();

            // map Google Timestamp to javascript Date
            data = mapFirebaseTimestampsToDate(data, ['startDt', 'endDt', 'previousStartDt', 'previousEndDt']);

            console.log('empMyCalendarServices loadInterviewCard data', data);
            setInterviewData({ interviewId, ...data });
            setInterviewCardOpen(true);
        }
    });
    // const interviewRef = db.collection('interviews').doc(interviewId);

    // interviewRef.get().then(doc => {
    //     if (doc.exists) {
    //         const data = doc.data();
    //         console.log('empMyCalendarServices loadInterviewCard data', data);
    //         setInterviewData({ interviewId, ...data });
    //         setInterviewCardOpen(true);
    //     }
    // });
};

export const loadInterviewNote = ({ isEmployer, interviewId, setInterviewNote }) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const interviewNotesRef = isEmployer ? db.collection('interviewNotesEmp') : db.collection('interviewNotes');
    const interviewNoteRef = interviewNotesRef.doc(interviewId);

    return interviewNoteRef.onSnapshot(doc => {
        if (doc.exists) {
            const note = _get(doc.data(), 'note');

            setInterviewNote(note);
        }
    });
};

export const markInterviewRead = ({ dashboardId, interviewId, isConfirmed, isDeclined }) => {
    const db = getFirestore();

    const dashboardRef = db.collection('dashboards').doc(dashboardId);
    if (isConfirmed) {
        dashboardRef.update({ unreadConfirmedInterviews: getArrayRemove(interviewId) });
    } else if (isDeclined) {
        dashboardRef.update({ unreadDeclinedInterviews: getArrayRemove(interviewId) });
    }
};

export const saveNote = async ({ isEmployer, interviewId, setIsNoteEnabled, setSnackbarMessage, setSnackbarErrorMessage, note = '' }) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const interviewNotesRef = isEmployer ? db.collection('interviewNotesEmp') : db.collection('interviewNotes');
    const interviewNoteRef = interviewNotesRef.doc(interviewId);

    try {
        await interviewNoteRef.set({ note });

        // console.log('Transaction successfully committed!');
        setSnackbarMessage(SNACK_BAR_MESSAGE_SAVE);
        setIsNoteEnabled(false);
    } catch (error) {
        console.error('Save note transaction failed: ', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const confirmInterview = ({ isEmployer, interviewId, setInterviewCardOpen, callback, setSnackbarMessage, setSnackbarErrorMessage, detachInterviewCardListener }) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, { status: INTERVIEW_STATUS_CONFIRMED, statusUpdatedByEmp: isEmployer, updateDt: now });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_CONFIRM);
            detachInterviewCardListener();
            setInterviewCardOpen(false);
            callback && callback();
        })
        .catch(function (error) {
            console.error('Confirm interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const declineInterview = ({ isEmployer, interviewId, setIsDeclineEnabled, declineReason, callback, setSnackbarMessage, setSnackbarErrorMessage }) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, { status: INTERVIEW_STATUS_DECLINED, declineReason: declineReason, statusUpdatedByEmp: isEmployer, updateDt: now });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_DECLINE);
            setIsDeclineEnabled(false);
            callback && callback();
        })
        .catch(function (error) {
            console.error('Decline interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

export const loadCurrentMonthInterviewsByUserId = (employerId, calendarData = {}, setInterviewList) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const currentMonthIdx = getMonth(_get(calendarData, 'w1d0.dt'));
    const firstDayOf6thWeek = _get(calendarData, 'w5d0.dt');
    const has6Weeks = currentMonthIdx === getMonth(firstDayOf6thWeek);
    const endDtPath = has6Weeks ? 'w5d6.dt' : 'w4d6.dt';

    const startDt = _get(calendarData, 'w0d0.dt', startOfMonth(new Date()));
    const endDt = _get(calendarData, endDtPath, endOfMonth(new Date()));

    const interviewsRef = db.collection('interviews').where('employerId', '==', employerId).where('startDt', '>=', startDt).where('startDt', '<=', endDt);
    console.log({ employerId });
    return interviewsRef.onSnapshot(querySnapshot => {
        const interviewList = _map(querySnapshot.docs, doc => {
            // console.log(doc.data());
            const data = doc.data();
            const startDt = _get(data, 'startDt');
            const startDtStartOfDay = startDt ? startOfDay(startDt.toDate()) : null;
            const dayId = _findKey(calendarData, item => isEqualDate(_get(item, 'dt'), startDtStartOfDay));
            return { interviewId: doc.id, dayId, ...data };
        });

        setInterviewList(interviewList);
    });
};

export const loadCurrentWeekInterviewsByUserId = (employerId, startDt, endDt, setInterviewList) => {
    // const db = firebase.firestore();
    const db = getFirestore();

    const interviewsRef = db.collection('interviews').where('employerId', '==', employerId).where('startDt', '>=', startDt).where('startDt', '<=', endDt);

    return interviewsRef.onSnapshot(querySnapshot => {
        let interviewList = [];

        _forEach(querySnapshot.docs, doc => {
            const data = doc.data();

            if (!_isEmpty(data.startDt) && !_isEmpty(data.endDt)) {
                interviewList.push({ interviewId: doc.id, ...data });
            }
        });

        console.log('@@@@ loadCurrentWeekInterviewsByUserId interviewList=', interviewList);

        setInterviewList(interviewList);
    });
};

export const saveRescheduleInterviewRequest = ({
    isEmployer,
    interviewId,
    startDt,
    endDt,
    proposedStartDt,
    proposedEndDt,
    setIsRescheduleEnabled,
    callback,
    setSnackbarMessage,
    setSnackbarErrorMessage,
}) => {
    // const db = firebase.firestore();
    const db = getFirestore();
    const now = new Date();

    const interviewRef = db.collection('interviews').doc(interviewId);

    return db
        .runTransaction(transaction => {
            // This code may get re-run multiple times if there are conflicts.
            return transaction.get(interviewRef).then(function (doc) {
                if (!doc.exists) {
                    throw new Error('Document does not exist!');
                }

                transaction.update(interviewRef, {
                    status: isEmployer ? INTERVIEW_STATUS_RESCHEDULE_EMP : INTERVIEW_STATUS_RESCHEDULE_JS,
                    startDt: proposedStartDt,
                    endDt: proposedEndDt,
                    previousStartDt: startDt,
                    previousEndDt: endDt,
                    statusUpdatedByEmp: isEmployer,
                    updateDt: now,
                });
            });
        })
        .then(function () {
            // console.log('Transaction successfully committed!');
            setSnackbarMessage(SNACK_BAR_MESSAGE_INTERVIEW_RESCHEDULED);
            setIsRescheduleEnabled(false);
            // setInterviewData({ ...interviewData, note });
            callback && callback();
        })
        .catch(function (error) {
            console.error('Request reschedule interview transaction failed: ', error);
            setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
        });
};

// export const loadProfileByUserId = (userId, setProfileData) => {
//     const db = getFirestore();

//     const profileRef = db.collection('profiles').doc(userId);

//     return profileRef.onSnapshot(docSnapshot => {
//         let data = docSnapshot.data();

//         data = mapFirebaseTimestampsToDate(data, ['createDt', 'updateDt']);
//         const resumeList = _get(data, 'resumeList');
//         const resumeListMappedDates = _map(resumeList, resume => {
//             return mapFirebaseTimestampsToDate(resume, ['updateDt']);
//         });
//         data = _fpSet('resumeList', resumeListMappedDates, data);

//         setProfileData({ ...data });
//     });
// };

// TEAM ALPHA

export const updateInterview = async (data, setSnackbarMessage, setSnackbarErrorMessage) => {
    const db = getFirestore();
    const { virtual } = data;
    const payload = {
        ...data,
        startDt: getCombinedDateTime(data.date, data.startTime),
        endDt: getCombinedDateTime(data.date, data.endTime),
        updateDt: new Date(),
    };
    delete payload.startTime;
    delete payload.endTime;
    delete payload.date;
    if (virtual) {
        delete payload.streetAddress1;
        delete payload.streetAddress2;
        delete payload.zipCode;
        delete payload.state;
        delete payload.country;
        delete payload.city;
        delete payload.cityLocation;
    }

    const userRef = db.collection('interviews').doc(data.uid);
    try {
        await userRef.set(payload);
        setSnackbarMessage(SNACK_BAR_MESSAGE_INTERVIEW_SUCCESS);
    } catch (error) {
        console.log('error', error);
        setSnackbarErrorMessage(SNACK_BAR_MESSAGE_OPERATION_FAILED);
    }
};

export const loadStatesList = async (setStatesList, country) => {
    const db = getFirestore();

    const statesRef = db.doc(`app/lovs/countries/${country}`);

    const doc = await statesRef.get();
    doc.exists && setStatesList(doc.data().stateList.map(s => s.name));
};

export const loadCitiesList = async (setCitiesList, country, province) => {
    const db = getFirestore();
    if (Boolean(country) && Boolean(province)) {
        const citiesRef = db.doc(`app/lovs/countries/${country}/states/${province}`);
        const doc = await citiesRef.get();
        doc.exists && setCitiesList(doc.data().cityList.map(s => s.name));
    }
};

export const loadCityLocation = async (setLoc, country, province, city) => {
    const db = getFirestore();

    const citiesRef = db.doc(`app/lovs/countries/${country}/states/${province}`);

    const doc = await citiesRef.get();
    doc.exists && setLoc(doc.data().cityList?.filter(c => c.name === city)[0]?.location);
};

export const getJobSeekers = set => {
    const db = getFirestore();
    const jobSeekersRef = db.collection('users').where('type', '==', USER_TYPE_JS);
    return jobSeekersRef.onSnapshot(docSnapshot => {
        set(docSnapshot.docs.map(doc => ({ uid: doc.id, ...doc.data() }))); //Do not expect the document to have uid; doc id is uid so append it.
    });
};

export const fetchActiveJobs = set => {
    const db = getFirestore();
    const jobsRef = db.collection('jobs').where('active', '==', true);
    return jobsRef.onSnapshot(docSnapshot => {
        set(docSnapshot.docs.map(doc => ({ ...doc.data(), uid: doc.id })));
    });
};
